import React from 'react';

const Goal = ({date, watermark}) => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  return ( 
    <div className="calendar-goal">
      <div className="goal">
      <h1>{month} {year} Goals</h1>
      </div>
      <div className="bullets">
        <p>•</p>
        <p>•</p>
        <p>•</p>
      </div>
      <p className="watermark">{watermark}</p>
    </div>
   );
}
 
export default Goal;